import React, { useState, useRef } from "react";
import { MeterIcon } from "../../../svgs";
import { FiEdit } from "react-icons/fi";
import { uploadMedia, deleteMedia } from "../../../services/upload-service";
import Loader from "../../../components/shared/loader";
import { UploadCloud } from "lucide-react";
import { camelCaseToWords } from "../../../utils/structure-words-utils";
import Heading from "../../../components/shared/heading";

const VehicleDetails = ({ vehicle, vehicleId, accountId, setVehicle }) => {
    const [isUploading, setIsUploading] = useState(false);
    const [uploadError, setUploadError] = useState(null);
    const fileInputRef = useRef(null);


    const handleImageClick = () => {
        fileInputRef.current?.click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        setIsUploading(true);
        setUploadError(null);

        try {
            // Step 1: Delete existing media if it exists
            if (vehicle?.media?.mediaId) {
                const deleteResponse = await deleteMedia(accountId, vehicle?.media?.mediaId);
                console.log(deleteResponse)
                if (deleteResponse.status !== 204) {
                    throw new Error(deleteResponse.data.message || 'Failed to delete existing media');
                }
            }

            // Step 2: Upload new image
            const uploadResponse = await uploadMedia(accountId, file, 'vehicle', vehicleId, "vehicleProfilePicture");
            if (uploadResponse.success) {
                // Update vehicle state with new media
                setVehicle((prev) => ({
                    ...prev,
                    media: {
                        fileName: uploadResponse.data?.data?.fileName,
                        fileType: uploadResponse.data?.data?.fileType,
                        mediaId: uploadResponse.data?.data?.mediaId,
                        signedThumUrl: uploadResponse.data?.data?.signedThumUrl || URL.createObjectURL(file),
                        signedUrl: uploadResponse.data?.data?.signedUrl || URL.createObjectURL(file),
                    },
                }));
            } else {
                throw new Error(uploadResponse.data.message || 'Failed to upload new image');
            }
        } catch (error) {
            setUploadError(error.message || 'An error occurred while updating the image');
        } finally {
            setIsUploading(false);
        }
    };

    const isImage = vehicle?.media?.signedThumUrl || vehicle?.media?.signedUrl;

    return (
        <div className="flex items-center gap-4">
            <div className="w-32 h-32 relative rounded-md overflow-hidden group">
                {
                    isImage ?
                        <img
                            src={isImage}
                            alt="Vehicle"
                            className="object-cover w-full h-full"
                        />
                        :
                        <div className="bg-gray-400 w-full cursor-pointer h-full text-white text-sm flex flex-col justify-center items-center" >
                            <UploadCloud className="w-8 h-8  mx-auto " />
                            <p>Uplaod Image</p>
                        </div>
                }

                {/* Edit icon on hover */}

                <div
                    className={`absolute inset-0 ${isImage ? "bg-black" : 'bg-transparent'}  bg-opacity-50 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200 cursor-pointer`}
                    onClick={handleImageClick}
                >
                    {isImage && <FiEdit className="text-white text-2xl" />}
                </div>
                {/* Hidden file input */}
                <input
                    type="file"
                    ref={fileInputRef}
                    className="hidden"
                    accept="image/*"
                    onChange={handleFileChange}
                />
                {/* Loading overlay */}
                {isUploading && (
                    <div className="absolute inset-0 bg-black bg-opacity-50 flex items-center justify-center">
                        <Loader />
                    </div>
                )}
                {/* Error message */}
                {uploadError && (
                    <div className="absolute bottom-0 left-0 right-0 bg-red-500 text-white text-xs text-center py-1">
                        {uploadError}
                    </div>
                )}
            </div>

            <div className="flex flex-col gap-1">
                {vehicle ? (
                    <>
                        <Heading className="!items-start">
                            {camelCaseToWords(vehicle.name)} [{vehicle.year} {vehicle.make} {vehicle.model}]
                        </Heading>
                        <p className="text-sm text-gray-600">
                            {camelCaseToWords(vehicle.vehicleType)}, {vehicle.year} {vehicle.make} {vehicle.model}, {vehicle.vin}, {vehicle.licensePlate}
                        </p>
                        <div className="flex flex-wrap font-medium gap-2 mt-2 text-sm">
                            <span className="py-1 flex items-center gap-1 text-gray-800">
                                <MeterIcon />
                                <span className="inline-block font-mono w-[15ch]">
                                    {vehicle.attributes.odometer || '----'}
                                </span>
                            </span>
                            <span
                                className={`px-2 py-0.5 rounded-md border border-green-600 text-sm font-medium capitalize text-center ${vehicle.status === "active"
                                    ? "bg-green-100 text-green-700"
                                    : vehicle.status === "inactive"
                                        ? "bg-red-100 text-red-700"
                                        : "bg-yellow-100 text-yellow-700"
                                    }`}
                            >
                                ● {vehicle.status}
                            </span>
                            {/* <span className="px-2 py-1 text-blue-700 flex items-center gap-1">
                                <img
                                    src={Profile}
                                    alt="user"
                                    width={20}
                                    height={20}
                                    className="rounded-full"
                                />
                                {vehicle?.creator?.name || 'Unknown User'}
                            </span> */}
                        </div>
                    </>
                ) : (
                    <div className="text-red-600">Vehicle with ID {vehicleId} not found.</div>
                )}
            </div>
        </div>
    );
};

export default VehicleDetails;